import React, { useState } from 'react';

import avatars from './../assets/img/avatars/2.png';
import { Link } from 'react-router-dom';
import { getUserDetail, getUserType, getDefaultLocale, setDefaultLocale} from './../helpers/Helper';
import PricingPlans from "./PricingPlans";

import { useTranslation } from 'react-i18next';
import useMounted from '../hooks/useMounted';

function Header(props) {
    const { t,i18n } = useTranslation();
    const [language ,setLanguage] = useState(getDefaultLocale());

    useMounted(() => {
        if(getUserType() === 'Admin'){
            i18n.changeLanguage('en')
        }else{
            i18n.changeLanguage(getDefaultLocale())
        }
    });

    const handleLangChange = () => {
        props.onChangeHandleMenu();
    }

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        setDefaultLocale(lng)
        setLanguage(lng);
    };
    return (
        <>
            <nav className="layout-navbar container-fluid navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
                id="layout-navbar">
                <div className="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none">
                    <Link className="nav-item nav-link px-0 me-xl-4" onClick={handleLangChange} to="#">
                        <i className="bx bx-menu bx-sm"></i>
                    </Link>
                </div>

                <div className="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
                   
                    {t('welcome')}
                    <ul className="navbar-nav flex-row align-items-center ms-auto">
                        {getUserType() === 'User' && <li className="nav-item dropdown-language dropdown me-2 me-xl-0">
                            <Link className="nav-link dropdown-toggle hide-arrow" to="#" data-bs-toggle="dropdown"  aria-expanded="true" style={{'textTransform' : 'uppercase'}}>
                                {language} <i className="bx bx-globe bx-md fs-24" ></i>
                            </Link>
                            <ul className="dropdown-menu dropdown-menu-end" data-bs-popper="static">
                                <li>
                                    <Link onClick={() => changeLanguage('en')} className="dropdown-item" to="#" data-language="en" data-text-direction="ltr">
                                        <span>English</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => changeLanguage('hi')} className="dropdown-item" to="#" data-language="fr" data-text-direction="ltr">
                                        <span>Hindi</span>
                                    </Link>
                                </li>
                            </ul>
                        </li>}
                        <li className='nav-item lh-1 me-3 ms-3'>
                            <p className='mb-0 ml-2 text-capitalize'>{getUserDetail()?.name}</p>
                        </li>
                        <li className="nav-item navbar-dropdown dropdown-user dropdown">
                            <Link className="nav-link dropdown-toggle hide-arrow" to="#"
                                data-bs-toggle="dropdown">
                                <div className="avatar avatar-online">
                                    <img src={avatars} alt="avatars" className="w-px-40 h-auto rounded-circle" />
                                </div>
                            </Link>
                            <ul className="dropdown-menu dropdown-menu-end">
                            {getUserType() === 'User' &&
                                <li>
                                    <Link className="dropdown-item" to={"/profile"}>
                                        <span className="d-flex align-items-center align-middle">
                                            <i className="flex-shrink-0 bx bx-user me-2"></i>
                                            <span className="flex-grow-1 align-middle ms-1">{t('sideMenu.myProfile')}</span>
                                        </span>
                                    </Link>
                                </li>
                            }
                                <li>
                                    <Link className="dropdown-item" to={(getUserType() === 'Admin') ? "/admin/change-password" : "/change-password"}>
                                        <span className="d-flex align-items-center align-middle">
                                            <i className="flex-shrink-0 bx bx-key me-2"></i>
                                            <span className="flex-grow-1 align-middle ms-1">{t('sideMenu.changePassword')}</span>
                                        </span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/logout" className="dropdown-item">
                                        <i className="bx bx-power-off me-2"></i>
                                        <span className="align-middle">{t('sideMenu.logOut')}</span>
                                    </Link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </nav>
            <PricingPlans />
        </>
    );
}

export default Header;